export default __webpack_public_path__ + "static/media/step_3.2fe957a6.svg";